/*.StoreContainer:hover .MoreContainer {
  opacity: 1;
}*/
.StoreContainer {
}
.StoreContainer:hover .MoreContainer {
  opacity: 1;
}
.MoreContainer {
  transition: opacity 0.3s;
  opacity: 0;
  cursor: pointer;
}
